import { useState, useEffect } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { PersonalInformationContainer, Banner } from './phoneConfirmation.styles';
import { Button } from 'src/utilities/UILibrary/UI/Button/Button';
import Card from 'src/utilities/UILibrary/UI/Card/Card';
import { InputField } from 'src/utilities/UILibrary/Forms/InputField/InputField';
import ConfirmOnboardingModal from 'src/components/shared/modals/onboardingSuccess/onboardingSuccess';
import { errorHandler } from 'src/middlewares/Auth/index.utilities';
import ModalError from 'src/components/shared/modals/Error/Error';
import {
  fetchPersonalInformationApplicant,
  fetchFilesInformation
} from 'src/store/Profile/profile.slice';
import { useManageSteps } from 'src/hooks/useManageSteps';
import { environment, url } from 'src/environments';
import { useNavigate } from 'react-router-dom';
import { setLoadingState } from 'src/store/User/user.slice';

export default function PhoneConfirmation() {
  //Steps to show the form options
  const [step, setStep] = useState(1);
  const [referenceId, setReferenceId] = useState('');
  const [mobilephone, setMobilephone] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [showFinishedModal, setShowFinishedModal] = useState(false);
  const [numberINE, setNumberINE] = useState('');
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.currentUser);
  const { nextStep } = useManageSteps();
  const navigate = useNavigate();

  useEffect(() => {
    if (user.id) {
      dispatch(fetchPersonalInformationApplicant(user.id));
    }
  }, [user.id, dispatch]);

  useEffect(() => {
    if (user.id) {
      dispatch(fetchFilesInformation(user.id)).then((action) => {
        if (fetchFilesInformation.fulfilled.match(action)) {
          const documentNumber = action.payload.data?.getFile.INE.documentNumber;
          setNumberINE(documentNumber || '');
        }
      });
    }
  }, [user.id, dispatch]);

  const resetInputs = () => {
    setStep(1);
    setMobilephone('');
    setVerificationCode('');
  };

  const handleGetCode = async (event) => {
    event.preventDefault();
    const mobileP = mobilephone.split(' ')[0] + mobilephone.split(' ')[1];
    const input = {
      id: user.id,
      typeOfUser: 'applicant'
    };
    //Ejecuta endpoint para crear cuenta de Efisys
    let efisys = {
      typeOperation: 'NR',
      registrationType: 'CO',
      bmxActivity: '0100008',
      ocupationNumber: 'N/A',
      registrationMotive: '1',
      tipoCliente: 'applicant',
      clienteId: user.id,
      notaryName: 'N/A',
      notaryNumber: 'N/A',
      inscriptionReg: 'N/A',
      publicDeed: '1900-02-29',
      foundationDate: '1900-02-29',
      idNumber: numberINE
    };
    const trully = {
      id: user.id,
      typeOfUser: 'applicant',
      phone: mobileP
    };
    await axios.post(`${url}/${environment}/efysis/customer/customer-registration`, efisys);
    const trullyTwo = await axios.post(
      `${url}/${environment}/trully/enrich-data/predict/second-step`,
      trully
    );
    const body = JSON.parse(trullyTwo.data.body);
    const label = body.label;
    if (label === 'No Threat') {
      //Ejecuta lambda para enviar código de verificación
      const phone = await axios.post(
        `${url}/${environment}/admin/mobile/${mobileP}/get-otp`,
        input
      );
      const parsedBody = JSON.parse(phone.data.body);
      const referenceId = parsedBody.ReferenceId;
      setReferenceId(referenceId);
      setStep(2);
    }
    navigate('/validation-page');
  };

  const handleValidateCode = async (event) => {
    event.preventDefault();
    const mobileP = mobilephone.split(' ')[0] + mobilephone.split(' ')[1];
    const body = {
      id: user.id,
      otp: verificationCode,
      referenceId: referenceId,
      typeOfUser: 'applicant'
    };

    dispatch(setLoadingState(true));
    const response = await axios.post(
      `${url}/${environment}/admin/mobile/${mobileP}/validate-otp`,
      body
    );
    const parsedBody = JSON.parse(response.data.body);
    const codeResponse = parsedBody.isVerified;
    if (codeResponse === true) {
      dispatch(setLoadingState(false));
      await nextStep();
      setShowFinishedModal(true);
    } else {
      dispatch(setLoadingState(false));
      errorHandler(dispatch, { code: 'incorrectPhoneCode' });
      console.error('Incorrect verification code.');
    }
  };

  return (
    <PersonalInformationContainer>
      <ModalError onReset={resetInputs} />
      <ConfirmOnboardingModal
        showModal={showFinishedModal}
        onClose={() => (window.location.href = '/solicitante/dashboard/mi-perfil')}
        typeOfUser="applicant"
      />
      <Banner>
        <figure>
          <img
            src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_inv_personalInformation6_banner.png`}
            alt="Finsphera configuración de seguridad"
          />
        </figure>
        <h2>Configuración de seguridad</h2>
      </Banner>
      <Card isSlim className="card-container">
        <p>
          {step === 1
            ? 'Tu seguridad es lo más importante, por eso es fundamental que mantengas actualizado tu número de celular. Proporciónanos tu teléfono celular a 10 dígitos:'
            : 'Ingresa el código de verificación que enviamos a tu número celular'}
        </p>
        <form onSubmit={step === 1 ? handleGetCode : handleValidateCode}>
          <InputField
            isDialCode
            value={mobilephone}
            onChangeInternalValue={(value) => setMobilephone(value)}
            placeholder="Número de teléfono"
            minLength={10}
            required
          />
          {step === 2 && (
            <>
              <InputField
                value={verificationCode}
                regex={/^\d{1,6}$/}
                restrictRegex
                errorRegexMessage="El código de verificación debe ser de 6 dígitos"
                onChangeInternalValue={(value) => setVerificationCode(value)}
                type="number"
                placeholder="Código de verificación"
                required
              />
              <Button isFullWidth size="small" type="submit">
                Validar código de verificación
              </Button>
            </>
          )}
          {step === 1 && (
            <Button isFullWidth size="small" type="submit">
              Enviar código de verificación
            </Button>
          )}
        </form>
      </Card>
    </PersonalInformationContainer>
  );
}
